import {
  RobotoNotFoundException,
  RobotoUnauthorizedException,
} from "@/shared/http";

/**
 * Why a shared View link did not open, in the recipient's terms.
 *
 * 401 means a View in the caller's own org they may not see; 404 means one in
 * another org. A 404 must never be reported as "deleted" — it is
 * indistinguishable from "not yours".
 */
export function viewLinkErrorMessage(error: unknown): string {
  if (error instanceof RobotoUnauthorizedException) {
    return "You don't have access to this view. Ask its author to share it with you.";
  }

  if (error instanceof RobotoNotFoundException) {
    // Not "deleted": a cross-org id reads as absent either way.
    return "This view isn't available. It may have been deleted, or it belongs to another organization.";
  }

  return "This view could not be opened.";
}
